import {
  create,
  Mutate,
  StateCreator,
  StoreApi,
  StoreMutatorIdentifier,
  UseBoundStore,
} from "zustand";

type State<T, Mos extends [StoreMutatorIdentifier, unknown][] = []> = {
  namedStores: Record<string, UseBoundStore<Mutate<StoreApi<T>, Mos>>>;
  setNamedStore: (
    key: string,
    value: UseBoundStore<Mutate<StoreApi<T>, Mos>>
  ) => void;
  getNamedStore: (key: string) => UseBoundStore<Mutate<StoreApi<T>, Mos>>;
};

export const useNamedStore = <T>(
  init: (key: string) => StateCreator<T, [], []>
) =>
  create<State<T>>()((set, get) => ({
    namedStores: {},

    setNamedStore: (key, value) =>
      set((state) => ({ namedStores: { ...state.namedStores, [key]: value } })),

    getNamedStore: (key) => {
      set((state) => {
        const namedStore = state.namedStores[key];

        if (namedStore !== undefined) {
          return state;
        }

        const newNamedStore = create<T>()(init(key));

        return { namedStores: { ...state.namedStores, [key]: newNamedStore } };
      });
      return get().namedStores[key];
    },
  }));
